/*
 * Build-time Feature Flags (Vite).
 *
 * import.meta.env.* liefert immer STRINGS. Ein truthy-Check waere daher
 * fehlerhaft: "false" ist truthy und wuerde das Flag faelschlich aktivieren
 * (siehe VITE_USE_SIDEBAR_V2 in ManagerComponent.tsx). Deshalb wird hier
 * explizit gegen "true" verglichen.
 *
 * Jedes Flag bekommt genau einen Accessor hier – nicht verteilt im Code
 * `import.meta.env.*` abfragen. Damit gilt die Auswertung ueberall gleich und
 * eine neue Variable ist an einer Stelle nachvollziehbar.
 */
const isEnabled = (value: unknown): boolean =>
    String(value ?? "").trim().toLowerCase() === "true";

/*
 * Variante A der Textverwaltung (/manager/configuration/texts).
 * false / nicht gesetzt => bisheriger Screen.
 */
export const useTextSearchV2 = (): boolean =>
    isEnabled(import.meta.env.VITE_USE_TEXTSEARCH_V2);

/*
 * SidebarV2 statt der Legacy-Sidebar (ManagerComponent).
 * Mandant 70447 hat eine eigene Sidebar und ignoriert das Flag.
 */
export const useSidebarV2 = (): boolean =>
    isEnabled(import.meta.env.VITE_USE_SIDEBAR_V2);

/*
 * Repolish-Variante der Dokumentensuche (DocumentSearchOverlayWrapper).
 * false / nicht gesetzt => bisheriger Dialog.
 */
export const useDocumentSearchV2 = (): boolean =>
    isEnabled(import.meta.env.VITE_USE_DOCUMENT_SEARCH_V2);

/*
 * Repolish-Variante der E-Mail-Maske (EmailModalWrapper).
 * false / nicht gesetzt => bisheriger Dialog.
 */
export const useEmailModalV2 = (): boolean =>
    isEnabled(import.meta.env.VITE_USE_EMAIL_MODAL_V2);

/*
 * Repolish-Variante des Buchungsinfo-Modals (Disposition: Plan-, Fahrzeug- und
 * Reservierungslog-Ansicht). false / nicht gesetzt => bisheriges Modal.
 */
export const useBookingInfoModalV2 = (): boolean =>
    isEnabled(import.meta.env.VITE_USE_BOOKING_INFO_MODAL_V2);

/*
 * Teilrechnungen. Die drei Flags stehen in .env.local, werden aber aktuell
 * von keiner Komponente ausgewertet – die Accessoren existieren, damit die
 * Auswertung beim Anschluss nicht wieder inline nachgebaut wird.
 */
export const usePartialInvoiceV2 = (): boolean =>
    isEnabled(import.meta.env.VITE_USE_PARTIAL_INVOICE_V2);

export const usePartialInvoiceRuns = (): boolean =>
    isEnabled(import.meta.env.VITE_USE_PARTIAL_INVOICE_RUNS);

export const usePartialInvoiceRunsMock = (): boolean =>
    isEnabled(import.meta.env.VITE_PARTIAL_INVOICE_RUNS_MOCK);
